function firstLetter() {
  return function (input) {
    return input ? input.charAt(0) : input;
  };
}

export default firstLetter;
